import React from "react";
import styles from "./Stripe.module.css";
import Button4 from "../button4/Button4";

const StripeRight = ({ items = [] }) => {
  return (
    <div className={styles.stripe}>
      <div className={`${styles.track} ${styles.right}`}>
        {[...items, ...items].map((item, i) => (
          <Button4
            key={i}
            text={item.text}
            color={item.color}
            bgColor={item.bgColor}
          />
        ))}
      </div>
    </div>
  );
};

export default StripeRight;